import { CARD_FORM } from '../form-card-type';
import { ICards } from '../../.././../models/cards.interface';
import { printCard } from '../../../../routes/print-cards';
import { showToast } from '../../../../components/toasts';

/**
 * Function to print Individual Cards
 * 
 * @param {object} data data to print new card
 * 
 * @returns void
 */
export const individualCardPrint = async (data: ICards) => {
  const { customerName, cardNumber, cardGroupName } = data;

  const { body } = await printCard(' ', cardNumber);

  if ( !Array.isArray(body) || body.length === 0 ) {
    showToast('aafp_toast-alert', 'Error getting card data');
  } else {
    const d = new Date();
    const month = (d.getMonth() + 1);
    const day = (d.getDate());
    const year = d.getFullYear();

    const fileName = `individiual_${customerName}_${cardGroupName}_${year}${month}${day}`;
    const formattedFileName = fileName.replace(/[^\w]/g, '');

    const replacer = (key: any, value: any) => value === null ? '' : value;
    const header = Object.keys(body[0]);
    
    const csvString = [
      header.join(','), 
      ...body.map((row: any) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
    ].join('\r\n');

    const hiddenElement = document.createElement('a');  
    hiddenElement.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csvString));
    hiddenElement.target = '_blank';        
    hiddenElement.setAttribute('download', formattedFileName + '.csv');  
    hiddenElement.click();
    CARD_FORM.printButton.classList.remove('aafp_button-loading');
  }
}